import React, { useState } from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import { Col, Container, Row } from 'reactstrap'
import arrow from "../../../assets/kangaroo/arrow-cropped.svg"
import "../InstitutionRepresent.css"
import Explore from '../../../Homepage/Explore'
import Map from '../../../Homepage/Map'
import SmallPage from '../../../Homepage/SmallPage'
import UniversityService from '../../../services/UniversityService'
import { useQuery } from '@tanstack/react-query'
import { imageBaseApi } from '../../../services/imageBaseApi'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const InstitutionRepresent = () => {
  const [visibleCount, setVisibleCount] = useState(24);

  const fetchData = async () => {
    const response = await UniversityService.getList()
    return response
  }

  const { isPending, error, data: universityData } = useQuery({
    queryKey: ["university"],
    queryFn: fetchData
  })

  const handleLoadMore = () => {
    if (visibleCount >= universityData?.length) {
      setVisibleCount(24);
    } else {
      setVisibleCount(universityData?.length || 0);
    }
  };

  return (
    <>
      <SectionContainer>
        <Container>
          <Row>
            <Col>
              <BreadCrumb
                items={[
                  { title: "HOME", link: "/" },
                  { title: "INSTITUTIONS WE REPRESENT" },
                ]}
                instituition={false}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <h1 className='font-level-4 mb-5 lh-1 '>INSTITUTIONS WE REPRESENT</h1>
            </Col>
          </Row>

          {/* University Grid */}
          <Row className='gy-4 '>
            {universityData?.slice(0, visibleCount).map((item, index) => (
              <Col
                xl={3}
                lg={4}
                md={6}
                sm={6}
                xs={12}
                key={index}
                className='p-2 d-flex justify-content-lg-between justify-content-center'
              >
                <Link to={`/institution/${item?.slug}`}>
                  <motion.div
                    className="d-flex justify-content-between border rounded align-items-center"
                    style={{
                      height: "126px",
                      width: "100%",
                      maxWidth: "235px"
                    }}
                    whileHover={{ scale: 1.15 }}
                  transition={{
                    duration: 0.3,
                    ease: "easeInOut"
                  }}
                  >
                    <img
                      src={imageBaseApi + item?.logoMedia?.url}
                      alt={item?.name || "University logo"}
                      style={{ height: "100%", width: "100%" }}
                      className="rounded"
                    />
                  </motion.div>
                </Link>
              </Col>
            ))}
          </Row>

          {/* Load More Button */}
          <Row className='mt-5'>
            <Col className='d-flex flex-column justify-content-center align-items-center' style={{ cursor: "pointer" }} onClick={handleLoadMore}>
              <h1 className='button-font-Ins text-center mb-3'>
                {universityData?.length > 24 && (
                  <span>
                    {visibleCount >= universityData?.length
                      ? "LOAD LESS INSTITUTION"
                      : "LOAD MORE INSTITUTION"}
                  </span>
                )}
              </h1>
              {universityData?.length > 24 && (
                <img
                  src={arrow}
                  className={visibleCount >= universityData?.length ? "rotate-180" : "rotate-90"}
                  alt="Load more arrow"
                  style={{ maxWidth: "50px" }}
                />
              )}
            </Col>
          </Row>
        </Container>
      </SectionContainer>

      <hr className='line' />

      <SectionContainer>
        <Explore />
      </SectionContainer>

      <SectionContainer>
        <hr className='line-explore' />
        <Map />
        <hr className='line-style-testprep' />
      </SectionContainer>

      <SectionContainer>
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  )
}

export default InstitutionRepresent